/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SmppUpdateMutation(
  $smppId: ID!,
  $displayName: String!,
  $ip:String!,
  $username: String!,
  $password: String!,
  $rxPort: PositiveInt!,
  $txPort: PositiveInt!,
  $sessionTimeoutInterval: Float!,
  $sessionAllowed: Int,
  $tps: Int,
  $isSticky: Boolean,
  $enquireLinkInterval: Float!,
  $maxReconnectAttempts: Int,
  $reconnectBackoffFactor: Float,
  $initialReconnectDelay: Float,
  $sourceAddressTon: Int,
  $sourceAddressNpi: Int,
  $destinationAddressTon: Int,
  $destinationAddressNpi: Int,
  $trunkType: TRUNK_TYPE!,
  $interfaceVersion: String!,
  $debuggingLevel: SMPP_DEBUGGING_LEVEL!
) {
  SmppUpdate(
    smppId: $smppId,
    displayName: $displayName,
    ip: $ip,
    username: $username,
    password: $password,
    rxPort: $rxPort,
    txPort: $txPort,
    isSticky: $isSticky,
    sessionTimeoutInterval: $sessionTimeoutInterval,
    sessionAllowed: $sessionAllowed,
    tps: $tps,
    enquireLinkInterval: $enquireLinkInterval,
    maxReconnectAttempts: $maxReconnectAttempts,
    reconnectBackoffFactor: $reconnectBackoffFactor,
    initialReconnectDelay: $initialReconnectDelay,
    sourceAddressTon: $sourceAddressTon,
    sourceAddressNpi: $sourceAddressNpi,
    destinationAddressTon: $destinationAddressTon,
    destinationAddressNpi: $destinationAddressNpi,
    trunkType: $trunkType,
    interfaceVersion:$interfaceVersion,
    debuggingLevel: $debuggingLevel
  ) {
    id,
    message
    status
  }
}
`
